import { render, staticRenderFns } from "./GatherVisitPurpose.vue?vue&type=template&id=6b1133a4&scoped=true&"
import script from "./GatherVisitPurpose.vue?vue&type=script&lang=js&"
export * from "./GatherVisitPurpose.vue?vue&type=script&lang=js&"
import style0 from "./GatherVisitPurpose.vue?vue&type=style&index=0&id=6b1133a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1133a4",
  null
  
)

export default component.exports